// extracted by mini-css-extract-plugin
module.exports = {"root":"drawer_root__2rg-p","toolbar":"drawer_toolbar__smMV-","searchTab":"drawer_searchTab__G_H0Q"};